const TitleH2 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h2
      className={`text-primary text-2xl font-normal md:text-4xl ${className}`}
    >
      {title}
    </h2>
  );
};

export default TitleH2;
